import { useEffect, useState } from 'react';
import type { Maybe } from 'graphql/jsutils/Maybe';
import type {
    IFloatingFilterParams,
    NumberFilterModel,
} from '@ag-grid-community/core';
import { useDebounce } from '@hooks/useDebounce';

interface UserCustomFilter {
    filterValue: Maybe<number | string>;
    setFilterValue: (value: string | number) => void;
}

export function useCustomNumberFilter(
    props: IFloatingFilterParams,
): UserCustomFilter {
    const [filterValue, setFilterValue] = useState<Maybe<number | string>>();
    const debouncedfilerValue = useDebounce(
        filterValue,
        props.filterParams.debounceMs ?? 0,
    );

    const colId = props.column.getColId();
    const filterModel = props.api.getFilterModel() as Record<
        string,
        NumberFilterModel
    >;

    const hasFilter = Object.keys(filterModel).includes(colId);

    useEffect(() => {
        if (hasFilter) {
            setFilterValue(filterModel[colId].filter ?? undefined);
        } else {
            setFilterValue(undefined);
        }
    }, [hasFilter]);

    useEffect(() => {
        const currentModel = props.api.getFilterModel();
        props.api.setFilterModel({
            ...currentModel,
            [colId]: {
                filterType: 'text',
                type: 'contains',
                filter: debouncedfilerValue,
            },
        });
    }, [debouncedfilerValue]);

    return {
        filterValue,
        setFilterValue,
    };
}
